import type { MarketMonitorWrite, MarketMonitorPreview } from './index';
import { YOUTUBE_MODES, isYoutubeCapability, youtubeTarget } from './youtubeTarget';

/** Verify target identity and public allocation before allowing any write to an older server. */
export function youtubeTargetScopeEchoesRequest(request: MarketMonitorWrite, preview: MarketMonitorPreview): boolean {
    const scopes = request.source_scopes.filter(scope => isYoutubeCapability(scope.capability));
    if (!scopes.length) return true;
    const normalized = preview.normalized_monitor;
    const echoedScopes = Array.isArray(normalized.source_scopes) ? normalized.source_scopes.filter(scope =>
        scope && typeof scope === 'object' && isYoutubeCapability(String(scope.capability))) : [];
    const requested = request.identifiers.filter(id => id.kind === 'source_url' && id.source_system === 'youtube');
    const echoed = Array.isArray(normalized.identifiers) ? normalized.identifiers.filter(id =>
        id && typeof id === 'object' && id.kind === 'source_url' && id.source_system === 'youtube') : [];
    if (scopes.length !== 1 || echoedScopes.length !== 1 || echoedScopes[0].capability !== scopes[0].capability) return false;
    if (scopes[0].capability === YOUTUBE_MODES.keyword)
        return echoed.length === requested.length && requested.every(id => echoed.some(actual => actual.value === id.value));
    const mode = scopes[0].capability === YOUTUBE_MODES.video ? 'video' : 'channel';
    try {
        const targets = new Set(requested.map(id => youtubeTarget(id.value, mode)));
        if (!targets.size || echoed.length !== targets.size || new Set(echoed.map(id => id.value)).size !== targets.size
            || echoed.some(id => !targets.has(String(id.value)))) return false;
        const allocation = preview.budget_allocations?.filter(item => item.capability === scopes[0].capability);
        if (allocation?.length !== 1 || allocation[0].source_system !== 'youtube' || allocation[0].scope.kind !== 'unfiltered'
            || allocation[0].logical_slices !== targets.size || allocation[0].physical_requests !== targets.size
            || allocation[0].comment_records !== 0 || allocation[0].max_records < targets.size) return false;
        if (mode === 'video' && (echoedScopes[0].max_records_per_slice !== 1 || allocation[0].max_records !== targets.size)) return false;
        return true;
    } catch { return false; }
}
